module.exports = __webpack_public_path__ + "media/assets/images/category/GetWell@2x-1d1b83d4cabedb1c317fce821a68ea45.png";